import React from 'react';

import { useBooleanState } from '@lumapps/lumx-hooks/hooks/useBooleanState';
import { useSelector } from '@lumapps/redux/react';

import { isReportFeatureEnabled } from '../ducks/selectors';
import { ReportedResourceType } from '../types';

/**
 * Setup for the report tunnel component.
 */
export const useReportTunnel = ({
    resourceId,
    resourceType,
}: {
    resourceType: ReportedResourceType;
    resourceId: string;
}) => {
    const reportButtonRef = React.useRef(null);
    const [isReportTunnelOpen, openReportTunnel, closeReportTunnel] = useBooleanState(false);
    const [isAlreadyReported, setIsAlreadyReported] = React.useState(false);
    const isEnabled = useSelector(isReportFeatureEnabled);
    const onReport = React.useCallback(
        (reported: boolean) => {
            closeReportTunnel();
            setIsAlreadyReported(reported);
        },
        [closeReportTunnel],
    );

    return {
        isEnabled,
        open: openReportTunnel,
        props: {
            isOpen: isReportTunnelOpen,
            resourceId,
            resourceType,
            reportButtonRef,
            onReport,
        },
        reportButtonRef,
        isAlreadyReported,
    };
};
